import { render, staticRenderFns } from "./DeviceWarrantyStatus.vue?vue&type=template&id=33db4890&scoped=true&"
import script from "./DeviceWarrantyStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceWarrantyStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33db4890",
  null
  
)

export default component.exports